module.exports = __webpack_public_path__ + "img/CHEVRON_BOTTOM.2fef06af.svg";